import { faker } from "@faker-js/faker";
import type { Consultation } from "../../src/global-providers/rxdb-provider/collections/consultation";

export const makeConsultation = (overrides = {}): Consultation => ({
  id: faker.string.uuid(),
  patientId: faker.string.uuid(),
  meta: {
    createdAt: faker.date.past().toISOString(),
    updatedAt: faker.date.past().toISOString(),
    createdByUserId: faker.string.uuid(),
    updatedByUserId: faker.string.uuid(),
  },
  diseaseIds: Array.from({ length: faker.number.int({ min: 1, max: 5 }) }, () =>
    faker.string.uuid(),
  ),
  freeTextDiagnoses: Array.from(
    { length: faker.number.int({ min: 1, max: 3 }) },
    () => ({
      id: faker.string.uuid(),
      name: faker.lorem.word(),
      category: faker.lorem.word(),
    }),
  ),
  plan: faker.helpers.arrayElement([null, faker.lorem.sentence()]),
  presentingComplaint: faker.helpers.arrayElement([
    null,
    faker.lorem.sentence(),
  ]),
  symptomIds: Array.from({ length: faker.number.int({ min: 1, max: 5 }) }, () =>
    faker.string.uuid(),
  ),
  problem: faker.helpers.arrayElement([null, faker.lorem.sentence()]),
  facilityId: faker.string.uuid(),
  organisationId: faker.string.uuid(),
  isImmunisation: faker.helpers.arrayElement([true, false, null]),
  isPerformedAtOtherClinic: faker.helpers.arrayElement([true, false, null]),
  backdatedTo: faker.helpers.arrayElement([
    null,
    faker.date.past().toISOString(),
  ]),
  ...overrides,
});
